/* 04 和のある食卓（2026-10-02）：楽しみ方の献立。押した場面から再生し、再生中の場面に印を付ける。
   再生の仕組みは本番の kazu-tanoshimikata-mobile.js のまま使う（まだ読み込んでいなければ「みんなの感想を見る」を押したのと同じ流れで読み込み、読めたらその秒へ）。 */
(() => {
  const init = (root) => {
    if (root.dataset.kondateOn) return;
    const menu = root.querySelector('[data-kz-kondate]');
    const video = root.querySelector('video');
    const start = root.querySelector('.start');
    const toggle = root.querySelector('.toggle');
    const player = root.querySelector('.player');
    if (!menu || !video || !start || !toggle || !player) return;
    root.dataset.kondateOn = '1';
    const items = [...menu.querySelectorAll('button[data-t]')];
    const ts = items.map((b) => Number(b.dataset.t));
    const mark = () => {
      const st = player.dataset.state;
      const live = st === 'playing' || st === 'paused' || st === 'ended';
      const t = video.currentTime || 0;
      let k = -1;
      if (live) ts.forEach((s, i) => { if (t >= s - 0.3) k = i; });
      items.forEach((b, i) => {
        b.classList.toggle('is-on', i === k);
        if (i === k) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    };
    video.addEventListener('timeupdate', mark);
    video.addEventListener('seeked', mark);
    video.addEventListener('ended', mark);
    const go = (t) => {
      if (!video.getAttribute('src')) {
        video.addEventListener('loadedmetadata', () => { try { video.currentTime = t; } catch (e) { /* 読めたあとで動く */ } }, { once: true });
        start.click();
      } else {
        try { video.currentTime = t; } catch (e) { /* noop */ }
        if (video.paused || video.ended) toggle.click();
      }
      const pic = root.querySelector('.picture');
      const r = pic && pic.getBoundingClientRect();
      if (r && (r.top < 0 || r.bottom > window.innerHeight)) pic.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    };
    items.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.t))));
  };
  const run = () => document.querySelectorAll('[data-kazu-experience]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
